import * as React from 'react'

import ViewOptionsDisplay from '~/client/src/shared/components/ViewOptions/ViewOptionsDisplay'
import SortOrder from '~/client/src/shared/enums/SortOrder'

import {
  useMobileResourceActions,
  useMobileResourceMeta,
  useMobileResourceState,
} from '../context'

export const MobileResourceViewOptions: React.FC = () => {
  const { grouping, sortKey, sortOrder } = useMobileResourceState()
  const { setGrouping, setSortKey, setSortOrder } = useMobileResourceActions()
  const { groupingOptions, sortingOptions, initialSortKey, initialSortOrder } =
    useMobileResourceMeta()

  return (
    <ViewOptionsDisplay
      grouping={
        groupingOptions.length
          ? {
              value: grouping,
              defaultValue: null,
              options: groupingOptions,
              onChange: setGrouping,
            }
          : undefined
      }
      sorting={
        sortingOptions.length
          ? {
              value: { key: sortKey, order: sortOrder },
              defaultValue: { key: initialSortKey, order: initialSortOrder },
              options: sortingOptions,
              onChange: value => {
                setSortKey(value.key)
                // Clearing the sort clears the direction too, so a stale
                // DESC can't silently resurface on the next field pick.
                setSortOrder(value.order ?? SortOrder.DEFAULT)
              },
            }
          : undefined
      }
    />
  )
}
